module.exports = __webpack_public_path__ + "img/ltkhalloween-4x.d3ea0dd.jpg";